<template>
  <v-container>
    <v-row>
      <v-col>
        <v-stepper vertical v-model="stepper" outline>
          <div
            v-for="(question, qindex) in questions"
            :key="`question-${qindex}`"
          >
            <v-stepper-step
              :step="qindex + 1"
              :complete="qindex + 1 < stepper"
              color="#BAC1B8"
            >
              {{
                stepper - 1 >= qindex
                  ? question.content
                  : `Question ${qindex + 1}`
              }}
              <small v-if="stepper - 1 > qindex && answers[qindex]">{{
                answers[qindex].content
              }}</small>
            </v-stepper-step>
            <v-stepper-content :step="qindex + 1">
              <div class="pl-5">
                <v-radio-group class="mt-0">
                  <v-radio
                    v-for="(answer, index) in question.answers"
                    :key="`answer-${index}`"
                    :label="answer.content"
                    :value="answer.id"
                    @change="
                      updateAnswers(qindex, {
                        ...answer,
                        weight: question.weight,
                      })
                    "
                    class="my-3"
                  ></v-radio>
                </v-radio-group>
              </div>
              <v-btn text @click="previousQuestion"> Retour </v-btn>
              <v-btn text @click="nextQuestion" :disabled="!answers[qindex]">
                {{
                  qindex === questions.length - 1
                    ? "Voir le résultat"
                    : "Suivant"
                }}
              </v-btn>
            </v-stepper-content>
          </div>
        </v-stepper>
        <results
          :filieres="filieres"
          :total="total"
          v-if="stepper === questions.length + 1"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Results from "@/components/Results.vue";
export default {
  components: { Results },
  props: ["questions", "filieres"],
  mounted() {
    this.questions.map((question) => {
      question.answers.sort((a, b) => a.id - b.id);
    });
  },
  data: () => ({
    stepper: 1,
    answers: [],
    total: 0,
  }),
  methods: {
    nextQuestion() {
      this.stepper += 1;
    },
    previousQuestion() {
      this.stepper -= 1;
    },
    updateAnswers(index, answer) {
      this.$set(this.answers, index, answer);
      this.computeResults();
      this.filieres.sort((a, b) => b.points - a.points);
    },
    computeResults() {
      this.filieres.map((filiere) => {
        filiere.points = this.answers
          .filter(
            (answer) =>
              answer.filieres &&
              answer.filieres.map((f) => f.filieres_id.id).indexOf(filiere.id) >
                -1
          )
          .map((a) => a.weight)
          .reduce((a, b) => a + b, 0);
      });
      this.total = this.filieres
        .map((f) => f.points)
        .reduce((a, b) => a + b, 0);
    },
  },
};
</script>

<style>
.v-stepper {
  box-shadow: none !important;
}
</style>